import { arrayToQueryString, toQueryParamsString } from 'src/utils/ApiUtils';
import { CreateContactOptions, EditContactOptions } from 'src/interfaces/api/Contact';

import { API_BASE_URL } from 'src/env';
import { ApiReturnType } from 'src/interfaces/api/api';

export default {
  get: (id: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/contacts/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  disable: (id: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/contacts/${id}/disable`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  enable: (id: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/contacts/${id}/enable`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getAll: (name, page = 1, limit = 10): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/contacts${toQueryParamsString({ name, page, limit })}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  create: (customerId: string, contact: CreateContactOptions): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/sites/${customerId}/contacts`,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(contact),
    credentials: 'include',
    method: 'POST',
  }),
  update: (contactId: string, contact: EditContactOptions): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/contacts/${contactId}`,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(contact),
    credentials: 'include',
    method: 'PUT',
  }),
  getBySite: (siteId: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/sites/${siteId}/contacts`,
    method: 'GET',
  }),
  getByEmail: (email: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/contacts/email/${email}`,
    method: 'GET',
  }),
  getByLegacyId: (legacyId: number): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/contacts/legacyId/${legacyId}`,
    method: 'GET',
  }),
  getByCustomerAccess: (customerAccessIds: string[]) => ({
    endpoint: `${API_BASE_URL}/v2/crm/contacts/customerAccess${arrayToQueryString('ids', customerAccessIds)}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
};
